
var novicell = novicell || {};

novicell.autocomplete = new function () {
    var self = this;
    self.autocompleteResults = {}; 

    this.init = function () {
        //var autocompleteResults = {};
        var autocompleteCache = {};

        $("#searchSpinner").hide(); // Hide the spinner per default



        $("#inputSearchGlobal").catcomplete({
            delay: 0,
            minLength: 2,
            source: function (request, response) {
                var term = request.term;
                if (term in autocompleteCache) {
                    var result = autocompleteCache[term];
                    self.autocompleteResults.CourseResults = result.CourseResults;
                    self.autocompleteResults.ServiceResults = result.ServiceResults;    
                    self.autocompleteResults.OtherResults = result.OtherResults;    
                    response(result);
                    return;
                }

                $.getJSON("/umbraco/api/searchapi/textsearch/", request, function (data, status, xhr) {
                    autocompleteCache[term] = data;
                    self.autocompleteResults.CourseResults = data.CourseResults;
                    self.autocompleteResults.ServiceResults = data.ServiceResults; 
                    self.autocompleteResults.OtherResults = data.OtherResults;
                    response(data);
                });
            },
            search: function (event, ui) {
                $("#searchSpinner").show();
            },
            response: function (event, ui) {
                $("#searchSpinner").hide();
            },
            open : function(){
                $(".result-list:visible").css({top:"+=20"});
                $(".result-list").width($('#inputSearchGlobal').outerWidth(true));
            },
            select: function (event, ui) {
                if (ui != null && ui.item != null && ui.item.Url) {
                    location.href = ui.item.Url;
                }
            }
        });

    };


    $.widget("custom.catcomplete", $.ui.autocomplete, {
        _create: function () {
            this._super();
            this.widget("#suggestionList").menu("option", "items", "> :not(.ui-autocomplete-category):not(.ui-autocomplete-block)").appendTo("#suggestionListContainer");
        },
        _renderMenu: function (ul, items) {
            var that = this,
                currentSection = "",
                showCourselist = self.autocompleteResults.CourseResults.Total > 0 ? true : false,
                showServicelist = self.autocompleteResults.ServiceResults.Total > 0 ? true : false,
                showOtherlist = self.autocompleteResults.OtherResults.Total > 0 ? true : false;

            ul.attr("class", "result-list");

            // Courses
            if (showCourselist) {
                ul.append("<li class='ui-autocomplete-category'>Katalog (" + self.autocompleteResults.CourseResults.Total + ")</li>");
            }

            $.each(self.autocompleteResults.CourseResults.List, function (index, item) {
                var li;
                item.label = item.Title;
                item.value = item.Title;
                li = that._renderItemData(ul, item);
                if (item.ContentSection) {
                    li.attr("aria-label", item.ContentSection + " : " + item.Title);
                }
            });
            if (self.autocompleteResults.CourseResults.SearchPageUrl && showCourselist) {
                ul.append("<li class='ui-autocomplete-block see-all'><a href=\"" + self.autocompleteResults.CourseResults.SearchPageUrl + "\" class='more' >Se hele kataloget</a></li>");
            }
            
            // Services
            if (showServicelist) {
                ul.append("<li class='ui-autocomplete-category'>Konsulentydelser (" + self.autocompleteResults.ServiceResults.Total + ")</li>");
            }

            $.each(self.autocompleteResults.ServiceResults.List, function (index, item) {
                var li;
                item.label = item.Title;
                item.value = item.Title;
                li = that._renderItemData(ul, item);
                if (item.ContentSection) {
                    li.attr("aria-label", item.ContentSection + " : " + item.Title);
                }
            });
            if (self.autocompleteResults.ServiceResults.SearchPageUrl && showServicelist) {
                ul.append("<li class='ui-autocomplete-block see-all'><a href=\"" + self.autocompleteResults.ServiceResults.SearchPageUrl + "\" class='more' >Se alle konsulentydelser</a></li>");
            }

            // Other pages
            if (showOtherlist) {
                ul.append("<li class='ui-autocomplete-category'>&Oslash;vrige sider (" + self.autocompleteResults.OtherResults.Total + ")</li>");
            }

            $.each(self.autocompleteResults.OtherResults.List, function (index, item) {
                var li;
                item.label = item.Title;
                item.value = item.Title;
                li = that._renderItemData(ul, item);
                if (item.ContentSection) {
                    li.attr("aria-label", item.ContentSection + " : " + item.Title);
                }
            });

            // Add the no-result message
            if(!showOtherlist && !showCourselist && !showServicelist) {
                ul.append("<li class='ui-autocomplete-block no-result'>Ingen resultat</li>");
            }
        },

        _renderItem: function (ul, item) {
            var link = $("<a>").attr("href", item.Url).append(item.Title).attr('class', 'more');
            var li = $("<li>").append(link);
            return li.appendTo(ul);
        }
    });

};